



































































































import { Component, Vue } from 'vue-property-decorator'
import changePwd from './ChangePwd.vue'
import rowEditor from '../../components/TextRowEditor.vue'
import settingService from '@/services/settingService'
import { ApiBooleanResult } from '@/services/data'
import numberRowEditor from '@/components/NumberRowEditor.vue'

@Component({
  components: {
    numberRowEditor,
    changePwd,
    rowEditor
  }
})
export default class UserSettings extends Vue {
  editing: string = null

  userSettings: Record<string, any> = {
    MaxNotFrequency: 0,
    AllTelegramNotification: false,
    ReportInterval: 20,
    ClientDownMinutes: 1,
    IgnoreStart: '',
    IgnoreEnd: ''
  }

  sysSettings = {
    NotificationBot: {
      Token: '',
      NameOfBot: ''
    }
  }

  async mounted () {
    const keys = Object.keys(this.userSettings)
    const usRes = await settingService.readUserSettingsByNamesAsync(keys)
    if (usRes.Error) {
      await this.$alert(usRes.Error)
    }
    if (usRes.Result) {
      usRes.Result.forEach(p => {
        if (p.Value === 'true') this.userSettings[p.Name] = true
        else if (p.Value === 'false') this.userSettings[p.Name] = false
        else {
          this.userSettings[p.Name] = p.Value
        }
      })
    }
    const sysRes = await settingService.readSysSettingByNamesAsync(['NotBot'])
    const notBotItem = sysRes.Result.find(p => p.Name === 'NotBot')
    if (notBotItem) {
      const notBotObj = JSON.parse(notBotItem.Value)
      this.sysSettings.NotificationBot.Token = notBotObj.Token
      this.sysSettings.NotificationBot.NameOfBot = notBotObj.NameOfBot
    }
  }

  async updateUserSetting (field: string) {
    const value = this.userSettings[field].toString()
    const res = await settingService.addOrUpdateUserSettingAsync([{
      Name: field,
      Value: value,
      ValueType: 'Number'
    }])
    await this.showMessage(res)
  }

  private async showMessage (res: ApiBooleanResult) {
    if (res.Error) {
      await this.$alert(this.$t('msg.' + (res.Error || 'unableToSave')) as string)
    } else {
      await this.$success(this.$t('msg.dataSaved') as string)
    }
  }
}
